/*
 * Free Shipping Progress Bar - lightweight AJAX refresh + animation helper.
 * No external libraries, no jQuery. Pure vanilla JS (~30 lines).
 * Called automatically after every AJAX cart render (add / update / remove)
 * so the bar always reflects the live cart state without a page reload.
 */
(function () {
  function refresh(root) {
    root = root || document;
    var fills = root.querySelectorAll('.fsb__fill');
    fills.forEach(function (fill) {
      var target = parseFloat(fill.getAttribute('data-percent'));
      if (isNaN(target)) return;
      if (target > 100) target = 100;
      if (target < 0) target = 0;
      fill.style.width = '0%';
      // force reflow so the transition always plays from 0 on every render
      void fill.offsetWidth;
      requestAnimationFrame(function () {
        fill.style.width = target + '%';
      });
    });

    root.querySelectorAll('.fsb--complete').forEach(function (el) {
      el.classList.add('fsb--celebrate');
      setTimeout(function () {
        el.classList.remove('fsb--celebrate');
      }, 900);
    });
  }

  window.FSB = { refresh: refresh };
  document.addEventListener('DOMContentLoaded', function () {
    refresh(document);
  });
})();
